/* Carried by Claus · todas las interacciones. El JS nunca calcula dinero: solo mueve ids y lee importes formateados por Liquid. */
(function () {
  'use strict';
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------- Ofertas ---------- */
  function selectOffer(card) {
    if (!card || card.classList.contains('is-disabled')) return;
    var form = card.closest('[data-cbc-form]');
    $$('[data-offer]', form).forEach(function (c) {
      var on = c === card;
      c.classList.toggle('is-active', on);
      c.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    $('[data-variant-input]', form).value = card.dataset.variantId;
    $('[data-qty-input]', form).value = card.dataset.qty || 1;

    /* El precio de arriba se queda fijo en el de 1 unidad (lo pinta Liquid); solo cambia la barra flotante. */
    var sp = $('[data-sticky-price]');
    if (sp) sp.textContent = card.dataset.priceNow;
  }

  document.addEventListener('click', function (e) {
    var card = e.target.closest('[data-offer]');
    if (card) selectOffer(card);
  });
  document.addEventListener('keydown', function (e) {
    var card = e.target.closest && e.target.closest('[data-offer]');
    if (card && (e.key === 'Enter' || e.key === ' ') && e.target === card) { e.preventDefault(); selectOffer(card); }
  });

  /* ---------- Galería ---------- */
  function selectGalleryImage(thumb) {
    var main = $('[data-gallery-main]');
    if (!main) return;
    main.removeAttribute('srcset');
    main.src = thumb.dataset.src;
    $$('[data-gallery-thumb]').forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-gallery-thumb]');
    if (t) selectGalleryImage(t);
  });

  /* ---------- Alta al carrito (producto + regalos + complementos marcados en un solo alta) ---------- */
  function collectItems(form) {
    var items = [{ id: +$('[data-variant-input]', form).value, quantity: +$('[data-qty-input]', form).value || 1 }];
    var active = $('[data-offer].is-active', form);
    if (active && active.dataset.surprise) { items[0].properties = {}; items[0].properties[active.dataset.surprise] = 'Included'; }
    if (active) {
      $$('[data-gift]:checked', active).forEach(function (cb) { items.push({ id: +cb.value, quantity: 1 }); });
      $$('[data-addon]:checked', active).forEach(function (cb) { items.push({ id: +cb.value, quantity: 1 }); });
    }
    return items;
  }
  function addToCart(form, then) {
    var err = $('[data-form-error]', form);
    if (err) err.hidden = true;
    $$('button', form).forEach(function (b) { b.disabled = true; });
    return fetch(root + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: collectItems(form) })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { window.location.href = root + then; })
      .catch(function (j) {
        $$('button', form).forEach(function (b) { b.disabled = false; });
        if (err) { err.textContent = (j && (j.description || j.message)) || "Couldn't add to cart. Please try again."; err.hidden = false; }
      });
  }
  function quickBuy(form) { return addToCart(form, 'checkout'); }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-cbc-form]');
    if (!form) return;
    e.preventDefault();
    addToCart(form, 'cart');
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-buy-now]');
    if (b) { e.preventDefault(); quickBuy(b.closest('[data-cbc-form]')); }
  });

  /* ---------- Carrito: repinta la sección cart-body ---------- */
  function cbcCartRequest(url, body) {
    var section = $('[data-cart-body]');
    if (section) section.classList.add('is-loading');
    body.sections = 'cart-body';
    return fetch(root + url, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (cart) {
      var html = cart.sections && cart.sections['cart-body'];
      var current = $('[data-cart-body]');
      if (html && current) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = $('[data-cart-body]', tmp);
        if (fresh) current.replaceWith(fresh);
      }
      updateCount(cart.item_count);
      clearOrphanGifts();
    }).catch(function () { window.location.reload(); });
  }
  /* Regalos sin disfraz en el carrito (se quitó el pack): se retiran para que no se compren solos a 0. */
  function clearOrphanGifts() {
    var c = $('[data-orphan-gifts]');
    if (!c) return;
    var u = {};
    c.dataset.orphanGifts.split(',').forEach(function (id) { if (id) u[id] = 0; });
    cbcCartRequest('cart/update.js', { updates: u });
  }
  function updateCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = !n; });
  }
  document.addEventListener('click', function (e) {
    var c = e.target.closest('[data-cart-change]');
    if (c) { e.preventDefault(); cbcCartRequest('cart/change.js', { id: c.dataset.cartChange, quantity: +c.dataset.qty }); return; }
    var a = e.target.closest('[data-addon-add]');
    if (a) { e.preventDefault(); var u = {}; u[a.dataset.addonAdd] = 1; cbcCartRequest('cart/update.js', { updates: u }); }
  });

  /* ---------- Cuenta atrás: corte de envío diario real, o fecha de fin real ---------- */
  function promoEnd() {
    var bar = $('[data-promo-end]');
    if (!bar) return NaN;
    var ts = +bar.dataset.promoTs;
    if (ts > 0) return ts * 1000;
    return bar.dataset.promoEnd ? new Date(bar.dataset.promoEnd.replace(' ', 'T')).getTime() : NaN;
  }
  var DAY_NAMES = ['', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
  function zonedNow(tz) {
    var p = {};
    new Intl.DateTimeFormat('en-GB', { timeZone: tz, weekday: 'short', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' })
      .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    return { wd: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].indexOf(p.weekday) + 1, sod: +p.hour * 3600 + +p.minute * 60 + +p.second };
  }
  /* Segundos hasta el próximo corte de envío y cuántos días faltan para ese envío (0 = hoy). */
  function nextShip(bar) {
    var hm = bar.dataset.shipCutoff.split(':'), cut = +hm[0] * 3600 + (+hm[1] || 0) * 60;
    var days = bar.dataset.shipDays.split(',').map(function (d) { return +d; });
    var now = zonedNow(bar.dataset.shipTz || 'America/New_York');
    for (var d = 0; d < 8; d++) {
      var wd = (now.wd - 1 + d) % 7 + 1;
      if (days.indexOf(wd) < 0 || (d === 0 && now.sod >= cut)) continue;
      return { s: d * 86400 + cut - now.sod, d: d, wd: wd };
    }
    return null;
  }
  function startCountdown() {
    var boxes = $$('[data-countdown]');
    if (!boxes.length) return;
    var ship = $('[data-ship-cutoff]'), end = promoEnd();
    if (!ship && (isNaN(end) || end <= Date.now())) return;
    if (ship && !nextShip(ship)) return;
    boxes.forEach(function (b) { b.hidden = false; });
    if (ship) $$('[data-cd-days]').forEach(function (el) { el.style.display = 'none'; if (el.nextElementSibling) el.nextElementSibling.style.display = 'none'; });
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    var timer;
    function tick() {
      var s, label = null, flatDays = true;
      if (ship) {
        var n = nextShip(ship);
        s = n.s; flatDays = false;
        label = n.d === 0 ? ship.dataset.shipToday : n.d === 1 ? ship.dataset.shipTomorrow : ship.dataset.shipLater.replace('[day]', DAY_NAMES[n.wd]);
      } else {
        s = Math.max(0, Math.floor((end - Date.now()) / 1000));
        if (s === 0) { boxes.forEach(function (b) { b.hidden = true; }); clearInterval(timer); return; }
      }
      var parts = flatDays
        ? { d: Math.floor(s / 86400), h: Math.floor(s % 86400 / 3600), m: Math.floor(s % 3600 / 60), s: s % 60 }
        : { d: 0, h: Math.floor(s / 3600), m: Math.floor(s % 3600 / 60), s: s % 60 };
      boxes.forEach(function (b) {
        if (label) $$('[data-cd-label], .cbc-countdown__label', b).forEach(function (el) { el.textContent = label; });
        var flat = $('[data-countdown-time]', b);
        if (flat) flat.textContent = (parts.d ? parts.d + 'd ' : '') + pad(parts.h) + ':' + pad(parts.m) + ':' + pad(parts.s);
        $$('[data-cd]', b).forEach(function (el) { el.textContent = pad(parts[el.dataset.cd]); });
      });
    }
    tick();
    timer = setInterval(tick, 1000);
  }

  /* ---------- Menú móvil ---------- */
  function setMenu(open) {
    var btn = $('[data-menu-toggle]'), menu = $('[data-menu]');
    if (!btn || !menu) return;
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    menu.hidden = !open;
    document.body.classList.toggle('cbc-menu-open', open);
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-toggle]')) { setMenu($('[data-menu]').hidden); return; }
    if (e.target.closest('[data-menu] a')) setMenu(false);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setMenu(false); });

  /* ---------- Reseñas: ver más ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-reviews-more]');
    if (!b) return;
    var hidden = $$('.cbc-rv.is-more[hidden]');
    hidden.slice(0, 9).forEach(function (el) { el.hidden = false; el.classList.add('is-visible'); });
    if (hidden.length <= 9) b.hidden = true;
  });

  /* ---------- Cifras que cuentan ---------- */
  function animateStatNumbers(el) {
    var to = parseFloat(el.dataset.countTo);
    if (isNaN(to) || reduced) return;
    var start = null, dur = 1400, done = false;
    function frame(ts) {
      if (!start) start = ts;
      var p = Math.min(1, (ts - start) / dur);
      el.textContent = Math.round(to * (1 - Math.pow(1 - p, 3))).toLocaleString('en-US');
      if (p < 1) requestAnimationFrame(frame); else done = true;
    }
    el.textContent = '0';
    requestAnimationFrame(frame);
    setTimeout(function () { if (!done) el.textContent = to.toLocaleString('en-US'); }, dur + 400); /* red de seguridad si se estrangula rAF */
  }

  /* ---------- Reveals, CTA flotante, parallax ---------- */
  function init() {
    var first = $('[data-offer].is-active');
    if (first) selectOffer(first);
    startCountdown();
    clearOrphanGifts();
    if (!$('[data-has-reviews]')) $$('[data-nav-reviews]').forEach(function (a) { a.hidden = true; });

    /* Vídeos: solo se reproducen en pantalla (y nunca con movimiento reducido) */
    var vids = $$('video[data-autoplay]');
    if (vids.length && 'IntersectionObserver' in window && !reduced) {
      var vo = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { var pr = en.target.play(); if (pr && pr.catch) pr.catch(function () {}); } else en.target.pause();
        });
      }, { threshold: 0.25 });
      vids.forEach(function (v) { vo.observe(v); });
    } else vids.forEach(function (v) { v.controls = true; });

    var reveals = $$('.cbc-reveal'), counters = $$('[data-count-to]');
    if (reduced || !('IntersectionObserver' in window)) {
      reveals.forEach(function (el) { el.classList.add('is-visible'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          en.target.classList.add('is-visible');
          io.unobserve(en.target);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
      reveals.forEach(function (el) { io.observe(el); });
      var co = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { animateStatNumbers(en.target); co.unobserve(en.target); } });
      }, { threshold: 0.5 });
      counters.forEach(function (el) { co.observe(el); });
    }

    var sticky = $('[data-sticky]'), buybox = $('.cbc-form');
    if (sticky && buybox && 'IntersectionObserver' in window) {
      sticky.hidden = false;
      new IntersectionObserver(function (entries) {
        var en = entries[0];
        var past = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', past);
      }).observe(buybox);
    }

    var par = $('[data-parallax] img');
    if (par && !reduced) {
      var ticking = false;
      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          var y = Math.min(window.scrollY, 600);
          par.style.transform = 'translateY(' + (-y * 0.04) + 'px) rotate(' + (y * 0.004) + 'deg)';
          ticking = false;
        });
      }, { passive: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
